import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useStoreActions from './actions';
import useCommonGetters from '../common-getters';
import { IProfilesState, Profile } from './models';

export const useProfilesStore = defineStore('profiles', () => {
  const state = ref(<IProfilesState>{
    profiles: [],
    profileOverview: {} as Profile,
    profileProperties: {} as Profile,
    profilePermissions: [],
    availableUsers: [],
    availablePermissions: [],
    shortNames: [],
    isCreateProfileDialogVisible: false,
    isAssignPermissionsDialogVisible: false,
    permissionTypes : []
  });

  return {
    ...toRefs(state.value),
    ...useStoreActions(state),
    ...useCommonGetters<IProfilesState>(state),
  };
});
